import { useEffect, useState } from 'react'

import clientAxios from '../config/axios'

const useBrand = () => {
  const [brands, setBrands] = useState([])

  useEffect(() => {
    const consultApi = async () => {
      await clientAxios
        .get('/brand/all')
        .then((response) => {
          setBrands(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    }

    consultApi()
  }, [])

  return [brands]
}

export default useBrand
